// extracted by mini-css-extract-plugin
module.exports = {"toast":"VerifyEmail__toast___3uOFv","checkmark":"VerifyEmail__checkmark___1jliW"};